<template>
  <div class="bf-bottom">
    <global-loading v-if="$store.state.vaStore.total_spend_vendor_loading" />
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadVendorRegion()"
        v-if="$store.state.vaStore.total_spend_vendor_level == 1"></i>
      <i class="fa-solid fa-circle-arrow-left" style="color:red" v-else @click="backLevel1()"></i>
    </div>
    <div class="text-bold">Total Spend Based on Vendor Region</div>
    <!-- <div class="btn border-black" style="font-size: 10px">
      Sort <i class="fa-solid fa-arrow-down"></i>
    </div> -->
    <div class="mt10 region-list scroll-hidden">
      <div class="flex flex-row" v-for="(list, index) in regions" :key="index" style="width: 100%; height: 25px;">
        <div class="region-container pointer" @click="goLevel2(list)">
          <p v-if="$store.state.vaStore.total_spend_vendor_level == 1">
            {{
              list.type == 'negara'
                ? list.negara
                : list.provinsi
                  ? list.provinsi
                  : 'undefined'
            }}
          </p>
          <p v-else>
            {{ list.desc ? list.desc : 'undefined' }}
          </p>
        </div>
        <div class="custom-bar-container">
          <div class="custom-bar-box" :style="`width: 100%`">
            <div style="width: 50%">
              <div class="custom-bar-color" :style="`width: calc(100% - ${list.percent}%)`">
                <div class="region-value ml10" :style="`width: 150px; position: absolute; right: -155px`">
                  {{ curencyDelimiter(list.total_value_usd) }} USD
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'

export default {
  components: {
    barChart: () => import('@/components/chart/dashboard/bar-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      // regions: [
      //   {
      //     name: 'Jawa Timur',
      //     value: 100000000,
      //     percent: 100 - (100 / 400) * 100,
      //   },
      //   {
      //     name: 'Berau',
      //     value: 250000000,
      //     percent: 100 - (250 / 400) * 100,
      //   },
      //   {
      //     name: 'Jakarta',
      //     value: 300000000,
      //     percent: 100 - (300 / 400) * 100,
      //   },
      //   {
      //     name: 'Kalimantan Timur',
      //     value: 350000000,
      //     percent: 100 - (350 / 400) * 100,
      //   },
      //   {
      //     name: 'Kalimantan Barat',
      //     value: 400000000,
      //     percent: 100 - (400 / 400) * 100,
      //   },
      // ],
    }
  },
  created() {
    // this.$store.dispatch('vaStore/getTotalSpendVendor')
  },
  computed: {
    regions() {
      const data = this.$store.state.vaStore.total_spend_vendor
      return this.convertData(data)
    },
  },
  methods: {
    async backLevel1() {
      await this.$store.dispatch('vaStore/getTotalSpendVendor')
    },
    async goLevel2(data) {
      await this.$store.dispatch('vaStore/getDetailTotalSpendVendor', {
        type: data.type,
        id: data.type == 'negara' ? data.negara_id : data.provinsi_id,
      })
    },
    totalValueUsd(data) {
      return data.reduce(function (a, b) {
        return parseFloat(a) + parseFloat(b.total_value_usd)
      }, 0)
    },
    convertData(data) {
      if (data && data.length > 0) {
        const totalValueUsd = this.totalValueUsd(data)

        let newData = []
        for (let i in data) {
          data[i].percent =
            100 -
            (parseFloat(data[i].total_value_usd) / parseFloat(totalValueUsd)) *
            100
          newData.push(data[i])
        }

        return newData
      }
      return []
    },
    async downloadVendorRegion() {
      let dateReport = moment().format('DDMMYY')
      let daterange = ''
      let start = this.$store.state.vaStore.start
      let end = this.$store.state.vaStore.end

      if (start && end) {
        daterange += `${start} - ${end}`
      }

      const total = await this.$store.dispatch(
        'vaStore/getTotalSpendVendorTotal'
      )
      total.unshift({})
      const detail = await this.$store.dispatch(
        'vaStore/getTotalSpendVendorDetail'
      )
      detail.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = ['Summary', 'Detail']

      sheet.forEach(list => {
        if (list == 'Summary') {
          let data = XLSX.utils.json_to_sheet(total)
          const title = [
            [
              `Total_Spend_Based_on_Vendor_Region_${dateReport}`,
              daterange,
              '',
              '',
              '',
            ],
            [
              'ID Negara',
              'ID Provinsi',
              'Negara',
              'Provinsi',
              'Total Value USD',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        } else {
          let data = XLSX.utils.json_to_sheet(detail)
          const title = [
            [
              `Total_Spend_Based_on_Vendor_Region_${dateReport}`,
              daterange,
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              '',
            ],
            [
              'Nama Vendor',
              'ID Negara',
              'ID Provinsi',
              'Provinsi',
              'Kota',
              'Isupplier Code',
              'Vendor ID SAP',
              'BCE Code',
              'GEMS Code',
              'BKES Code',
              'Ariba Code',
              'Total Value USD',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        }
      })
      XLSX.writeFile(wb, 'REPORT_TOTAL_SPEND_VENDOR_REGION.xlsx')
    },
  },
}
</script>
<style scoped>
.region-container {
  width: 40%;
  font-size: 12px;
  font-weight: bold;
  border-top: 0.5px solid rgba(128, 128, 128, 0.3);
  border-right: 0.5px solid rgba(128, 128, 128, 0.3);
  text-align: right;
  padding-right: 5px;
}

.custom-bar-container {
  width: 60%;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.custom-bar-box {
  display: flex;
  height: 15px;
}

.custom-bar-color {
  border: 0.3px solid rgba(255, 192, 203);
  background: rgba(255, 102, 102, 1);
  background: linear-gradient(90deg,
      rgba(255, 102, 102, 1) 0%,
      rgba(255, 102, 102, 0.5) 50%,
      rgba(255, 255, 255, 1) 100%);
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.region-value {
  font-size: 12px;
}

.region-list {
  width: 100%;
  height: 80%;
  overflow-y: auto;
}
</style>
